// const base = 'https://jjbh.ctkey.com.cn' // 测试服
const base = 'https://www.zhongguojd.com' // 正式服
// const base = 'http://jujiabaihui.com' // 廖俊龙
const path = {
  base_path: base,
  public_path: `${base}/Api/`,
  recommend_path: `${base}/Wechat`,
  is_app: 0 // 0为wap端 1为app端
}

export default path



// WEBPACK FOOTER //
// ./src/config/index.js